/** Parses the optional build-time ICE server JSON without retaining browser state. */
export function parseConfiguredIceServers(raw: unknown): readonly RTCIceServer[] {
  if (raw === undefined || raw === null || raw === '') return [];
  if (typeof raw !== 'string') throw new Error('INVALID_ICE_SERVERS_CONFIG');

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    throw new Error('INVALID_ICE_SERVERS_CONFIG', { cause: error });
  }
  if (!Array.isArray(parsed) || parsed.length > 8) throw new Error('INVALID_ICE_SERVERS_CONFIG');

  return parsed.map((entry) => {
    if (!entry || typeof entry !== 'object') throw new Error('INVALID_ICE_SERVERS_CONFIG');
    const value = entry as Record<string, unknown>;
    const urls = value.urls;
    const normalizedUrls =
      typeof urls === 'string'
        ? urls
        : Array.isArray(urls) && urls.every((url) => typeof url === 'string')
          ? urls
          : undefined;
    if (!normalizedUrls) throw new Error('INVALID_ICE_SERVERS_CONFIG');
    const username = value.username;
    const credential = value.credential;
    if (username !== undefined && typeof username !== 'string') {
      throw new Error('INVALID_ICE_SERVERS_CONFIG');
    }
    if (credential !== undefined && typeof credential !== 'string') {
      throw new Error('INVALID_ICE_SERVERS_CONFIG');
    }
    return {
      urls: normalizedUrls,
      ...(username === undefined ? {} : { username }),
      ...(credential === undefined ? {} : { credential }),
    } satisfies RTCIceServer;
  });
}

/** Parses the optional transport policy used by public forced-TURN validation. */
export function parseIceTransportPolicy(raw: unknown): 'all' | 'relay' {
  if (raw === undefined || raw === null || raw === '') return 'all';
  if (raw === 'all' || raw === 'relay') return raw;
  throw new Error('INVALID_ICE_TRANSPORT_POLICY');
}
